const findById = (id, array) => {
  if (!Array.isArray(array)) {
    return undefined;
  }

  // TODO: move into predicates utilities as an id => item => result type of function
  const predicate = (item) => (item ? item.id === id : false);
  return array.find(predicate);
};

// noinspection JSUnusedGlobalSymbols
export default findById;
